(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csg-threat-modelling-sessions"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('csg-sessions')) {
  customElements.define('csg-sessions', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.selector = this.querySelector('[data-game-selector]');
      this.enquiryGame = this.querySelector('[data-enquiry-game]');
      this.host = this.querySelector('[data-widget-host]');
      this.heading = this.querySelector('[data-dates-heading]');
      this.status = this.querySelector('[data-booking-status]');
      this.link = this.querySelector('[data-booking-link]');
      this.deck = this.querySelector('[data-deck-link]');
      this.selectorDeck = this.querySelector('[data-selector-deck-link]');
      this.privateGame = this.querySelector('[data-private-game]');
      this.expertHost = this.querySelector('[data-expert-host]');
      this.facilitatorHeading = this.querySelector('[data-facilitator-heading]');
      this.facilitatorInput = this.querySelector('[data-enquiry-facilitator]');
      const restoredFacilitator = this.facilitatorInput?.value;
      if (this.facilitatorInput) this.facilitatorInput.readOnly = true;
      this.classList.add('is-enhanced');
      this.querySelector('[data-enquire]').hidden = false;
      if (this.enquiryGame) {
        const restored = Array.from(this.selector.options).find(option => option.dataset.name === this.enquiryGame.value);
        if (restored) this.selector.value = restored.value;
        this.enquiryGame.readOnly = true;
      }
      this.selector.disabled = false;
      this.onChange = () => this.update();
      this.selector.addEventListener('change', this.onChange);
      this.onClick = event => {
        const trigger = event.target.closest('[data-enquire]');
        if (trigger && this.contains(trigger)) {
          if (this.facilitatorInput) this.facilitatorInput.value = trigger.dataset.facilitator;
          const enquiry = this.querySelector('.csg-enquiry');
          enquiry.open = true;
          const firstField = enquiry.querySelector('input[name="contact[name]"]');
          enquiry.scrollIntoView?.({behavior: 'smooth', block: 'nearest'});
          firstField?.focus({preventScroll: true});
        }
        const changeGame = event.target.closest('[data-change-game]');
        if (changeGame && this.contains(changeGame)) {
          event.preventDefault();
          this.selector.scrollIntoView?.({behavior: 'smooth', block: 'center'});
          this.selector.focus({preventScroll: true});
        }
      };
      this.addEventListener('click', this.onClick);
      this.update();
      const restoredExpert = this.expertHost.querySelector('[data-expert-name]')?.dataset.expertName;
      if (this.facilitatorInput && restoredFacilitator === restoredExpert) this.facilitatorInput.value = restoredFacilitator;
    }
    disconnectedCallback() {
      this.selector?.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.initialised = false;
    }
    bookingUrl(raw) {
      try {
        const url = new URL(raw);
        if (url.protocol === 'https:' && ['www.tickettailor.com', 'tickettailor.com'].includes(url.hostname)) return url.href;
      } catch (error) {}
      return '';
    }
    deckUrl(raw) {
      try {
        const url = new URL(raw, location.origin);
        if (['http:', 'https:'].includes(url.protocol)) return url.href;
      } catch (error) {}
      return '';
    }
    update() {
      const option = this.selector.selectedOptions[0];
      const specific = Boolean(option.value);
      this.privateGame.textContent = specific ? option.dataset.name : this.messages.unsure;
      const profile = Array.from(this.querySelectorAll('template[data-expert-profile]')).find(template => template.dataset.expertProfile === option.value);
      this.expertHost.replaceChildren();
      this.expertHost.hidden = !profile;
      this.facilitatorHeading.hidden = !profile;
      if (profile) this.expertHost.append(profile.content.cloneNode(true));
      if (this.facilitatorInput) this.facilitatorInput.value = 'CyberSec Games';
      const comingSoon = specific && option.dataset.comingSoon === 'true';
      const boxOffice = this.bookingUrl(this.dataset.boxOffice);
      const booking = comingSoon ? '' : (specific ? this.bookingUrl(option.dataset.bookingUrl) : boxOffice);
      const sharedCalendar = booking && new URL(booking).pathname.startsWith('/all-tickets') && !new URL(booking).searchParams.get('srch');
      const deck = this.deckUrl(option.dataset.deckUrl || '');
      if (this.enquiryGame) this.enquiryGame.value = specific ? option.dataset.name : this.messages.unsure;
      this.deck.hidden = !specific || !option.dataset.deckUrl || !deck;
      this.selectorDeck.hidden = this.deck.hidden;
      if (!this.deck.hidden) { this.deck.href = deck; this.selectorDeck.href = deck; }
      this.heading.textContent = comingSoon ? this.messages.soon + ' · ' + option.dataset.name : (specific && !sharedCalendar ? this.messages.dates + ' · ' + option.dataset.name : this.messages.allDates);
      this.status.textContent = comingSoon ? this.messages.soonCopy : (booking ? (specific && sharedCalendar ? this.messages.calendarNote : '') : this.messages.pending);
      this.link.textContent = booking ? this.messages.book : this.messages.all;
      this.link.hidden = comingSoon || (!booking && !boxOffice);
      this.link.href = booking || boxOffice;
      this.host.replaceChildren();
      if (!booking) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'tt-widget';
      const fallback = document.createElement('div');
      fallback.className = 'tt-widget-fallback';
      const fallbackLink = document.createElement('a');
      fallbackLink.href = booking;
      fallbackLink.target = '_blank';
      fallbackLink.rel = 'noopener';
      fallbackLink.textContent = this.messages.book;
      const attribution = document.createElement('small');
      const powered = document.createElement('a');
      powered.href = 'https://www.tickettailor.com?rf=wdg_348944';
      powered.className = 'tt-widget-powered';
      powered.textContent = this.messages.powered;
      attribution.append(powered);
      const paragraph = document.createElement('p');
      paragraph.append(fallbackLink, document.createElement('br'), attribution);
      fallback.append(paragraph);
      const script = document.createElement('script');
      script.src = 'https://cdn.tickettailor.com/js/widgets/min/widget.js';
      script.dataset.url = booking;
      script.dataset.type = 'inline';
      script.dataset.inlineMinimal = 'true';
      script.dataset.inlineShowLogo = 'false';
      script.dataset.inlineBgFill = 'true';
      script.dataset.inlineInheritRefFromUrlParam = '';
      script.dataset.inlineRef = 'website_widget';
      script.addEventListener('error', () => {
        if (wrapper.isConnected) this.status.textContent = this.messages.error;
      }, {once:true});
      wrapper.append(fallback, script);
      this.host.append(wrapper);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
